import React from "react";
import { createRoot } from "react-dom/client";
import {BrowserRouter} from "react-router";
import { Reshaped } from "reshaped";
import '../utils/i18n';
import "../../../assets/stylesheets/reshaped/gintoTheme/theme.css";
import {SearchMap} from "./search_map";

let root: any = null;

function render(node: any) {
    const App = () => {
        return (
            <BrowserRouter>
                <Reshaped theme="gintoTheme">
                    <SearchMap />
                </Reshaped>
            </BrowserRouter>
        );
    };

    root = createRoot(node);
    root.render(<App />);
}

function destroy() {
    root.unmount();
}

export { destroy, render };
